import { Routes } from '@angular/router';
import { CallbackComponent } from './core/callback/callback.component';
import { AuthGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  {
    path: 'dashboard',
    title: 'Ciberlens',
    loadComponent: () =>
      import('./pages/cisos/dashboard/main-content/main-content.component').then(m => m.MainContentComponent),

    children: [
      {
        path: 'endpointsecurity',
        title: 'Ciberlens',
        loadComponent: () =>
          import('./pages/cisos/dashboard/endpoint-security/endpoint-security.component').then(m => m.EndpointSecurityComponent),
        // canActivate: [AuthGuard],
        // data: { roles: ['CISO GLOBAL', 'CISO LOCAL'] },
      },
      {
        path: 'useridentity',
        title: 'Ciberlens',
        canActivate: [AuthGuard],
        data: { roles: ['CISO GLOBAL', 'CISO LOCAL'] },
        loadComponent: () =>
          import('./pages/cisos/dashboard/user-identity/user-identity.component').then(m => m.UserIdentityComponent),
      },
    ],
  },
  {
    path: 'entities',
    title: 'Ciberlens',
    canActivate: [AuthGuard],
    data: { roles: ['CISO GLOBAL', 'CISO LOCAL'] },
    loadComponent: () =>
      import('./pages/cisos/entities/entities.component').then(m => m.EntitiesComponent),
  },
  {
    path: 'entities-manager',
    title: 'Ciberlens',
    canActivate: [AuthGuard],
    data: { roles: ['ADMINISTRATOR'] },
    loadComponent: () =>
      import('./pages/admin/entities-manager/org-chart-all-entities/org-chart-all-entities.component').then(m => m.OrgChartAllEntitiesComponent),
  },
  {
    path: 'entities-manager/:continent',
    title: 'Ciberlens',
    canActivate: [AuthGuard],
    data: { roles: ['ADMINISTRATOR'] },
    loadComponent: () =>
      import('./pages/admin/entities-manager/org-chart-all-entities/org-chart-all-entities.component').then(m => m.OrgChartAllEntitiesComponent),
  },
  {
    path: 'entity-detail/:entityId/:entityName/:viewType',
    canActivate: [AuthGuard],
    data: { roles: ['CISO GLOBAL', 'CISO LOCAL'] },
    loadComponent: () =>
      import('./pages/cisos/entities/entity-detail/entity-detail.component').then(m => m.EntityDetailComponent),
  },
  {
    path: 'platforms',
    title: 'Ciberlens',
    canActivate: [AuthGuard],
    data: { roles: ['CISO GLOBAL', 'CISO LOCAL'] },
    loadComponent: () =>
      import('./pages/cisos/platforms/platforms.component').then(m => m.PlatformsComponent),
  },
  {
    path: 'platform-detail/:organizationalUnitId/:entityName/:selectedPlatformName/:viewType',
    canActivate: [AuthGuard],
    data: { roles: ['CISO GLOBAL', 'CISO LOCAL'] },
    loadComponent: () =>
      import('./pages/cisos/platforms/platform-detail/platform-detail.component').then(m => m.PlatformDetailComponent),
  },
  {
    path: 'file-upload',
    title: 'Ciberlens',
    canActivate: [AuthGuard],
    data: { roles: ['ADMINISTRATOR'] },
    loadComponent: () =>
      import('./pages/admin/file-upload/file-upload.component').then(m => m.FileUploadComponent),
  },
  {
    path: 'categories',
    title: 'Ciberlens',
    canActivate: [AuthGuard],
    data: { roles: ['ADMINISTRATOR'] },
    loadComponent: () =>
      import('./pages/admin/categories/categories.component').then(m => m.CategoriesComponent),
  },
  {
    path: 'kpi-management',
    title: 'Ciberlens',
    canActivate: [AuthGuard],
    data: { roles: ['ADMINISTRATOR'] },
    loadComponent: () =>
      import('./pages/admin/kpimanagement/kpimanagement.component').then(m => m.KpimanagementComponent),
  },
  {
    path: 'all-entities',
    title: 'Ciberlens',
    canActivate: [AuthGuard],
    data: { roles: ['ADMINISTRATOR'] },
    loadComponent: () =>
      import('./pages/admin/entities-manager/org-chart-all-entities/org-chart-all-entities.component').then(m => m.OrgChartAllEntitiesComponent),
  },
  {
    path: 'user-management',
    title: 'Ciberlens',
    canActivate: [AuthGuard],
    data: { roles: ['ADMINISTRATOR'] },
    loadComponent: () =>
      import('./pages/admin/user-management/user-management.component').then(m => m.UserManagementComponent),
  },
  {
    path: 'login',
    title: 'Ciberlens',
    loadComponent: () =>
      import('./core/auth-redirect/auth-redirect.component').then(m => m.AuthRedirectComponent),
  },
  {
    path: 'callback',
    component: CallbackComponent,
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'login',
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: 'login',
  },
];
